import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';

import CopyContentBlock from './elements/CopyContentBlock';
import messages from './AssessmentID.messages';

const AssessmentID = ({ intl, data }) => {
  const value = data?.fieldValue || '-';

  return (
    <div className="d-flex flex-column justify-content-start mb-5">
      <CopyContentBlock
        label={intl.formatMessage(messages['profile.assessment-id.label'])}
        value={value}
        headingId="assessment-id-header"
      />
    </div>
  );
};

AssessmentID.propTypes = {
  data: PropTypes.shape({
    fieldName: PropTypes.string.isRequired,
    fieldValue: PropTypes.string,
  }),
  intl: intlShape.isRequired,
};

AssessmentID.defaultProps = {
  data: {},
};

export default injectIntl(AssessmentID);
